import type React from "react";

import { SignUpReport } from "../components/SignUpReport";

export const SignUpQuestions: React.FC = () => {
  return (
    <div data-testid="sign-up-questions">
      <SignUpReport />
    </div>
  );
};
